import { Injectable } from '@angular/core';
import { LocalStorageService } from '@mynexus/mynexus-ui-lib';
import { UserConfig } from '@core/model/user-config';
import { QueueTypes } from '@core/enumeration';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class UserConfigService {
  constructor(
    private localStorage: LocalStorageService,
    private authenticationService: AuthenticationService
  ) {}

  private readonly STORAGE_KEY = 'userConfig';

  private configMap = new Map();
  private userConfig: UserConfig;

  /**
   * Set the default queue configuration for the user in the local storage per email
   * @param selectedQueue
   */
  saveCurrentQueue(selectedQueue: string): void {
    this.getUserConfig();

    const config = {
      ...this.userConfig,
      defaultQueue: selectedQueue
    };

    this.configMap.set(this.authenticationService.getEmail, config);
    this.saveToStorage();
  }

  getUserPrioritizedQueue(): QueueTypes {
    const queueList = new Map<string, UserConfig>(JSON.parse(this.localStorage.getItem(this.STORAGE_KEY)));
    const queueItem = queueList.get(this.authenticationService.getEmail);

    return queueItem?.defaultQueue as QueueTypes;
  }

  private saveToStorage() {
    const config = JSON.stringify(Array.from(this.configMap.entries()));
    this.localStorage.setItem(this.STORAGE_KEY, config);
  }

  /**
   * Get the user configuration from the local storage
   */
  private getUserConfig(): void {
    const userConfig = this.localStorage.getItem(this.STORAGE_KEY);

    if (userConfig) {
      this.configMap = new Map(JSON.parse(userConfig));
      this.userConfig = this.configMap.get(this.authenticationService.getEmail);
    }
  }
}
